import { ClubCurrencyType } from '../../enum/club-currency';
import { CustomerScoreTranslationsService } from '../../../shared/translations/customer/customer-score-translations.service';
import { Currency } from '../reusables/currency';

/**
 * Blueprint for the magento orders.
 */
export class CustomerScore {
  public '@id': string;
  public score: number;
  public activityBadge: CustomerScoreItem;
  public ticketQuantityBadge: CustomerScoreItem;
  public merchQuantityBadge: CustomerScoreItem;
  public merchRevenueBadge: CustomerScoreItem;
  public ticketRevenueBadge: CustomerScoreItem;

  public earnedArray = [];
  public notEarnedArray = [];

  constructor(customerScore: any, private customerScoreTranslations: CustomerScoreTranslationsService, preferredCurrency: ClubCurrencyType) {
    this['@id'] = customerScore['@id'];
    this.score = customerScore.score;
    this.activityBadge = customerScore.activityBadge ?
      new CustomerScoreItem(customerScore.activityBadge, this.customerScoreTranslations, preferredCurrency) : null;
    this.ticketQuantityBadge = customerScore.ticketQuantityBadge ?
      new CustomerScoreItem(customerScore.ticketQuantityBadge, this.customerScoreTranslations, preferredCurrency) : null;
    this.merchQuantityBadge = customerScore.merchQuantityBadge ?
      new CustomerScoreItem(customerScore.merchQuantityBadge, this.customerScoreTranslations, preferredCurrency) : null;
    this.merchRevenueBadge = customerScore.merchRevenueBadge ?
      new CustomerScoreItem(customerScore.merchRevenueBadge, this.customerScoreTranslations, preferredCurrency) : null;
    this.ticketRevenueBadge = customerScore.ticketRevenueBadge ?
      new CustomerScoreItem(customerScore.ticketRevenueBadge, this.customerScoreTranslations, preferredCurrency) : null;

    this.setUp();
  }

  private setUp() {
    this.arrangeBadge(this.activityBadge);
    this.arrangeBadge(this.ticketQuantityBadge);
    this.arrangeBadge(this.merchQuantityBadge);
    this.arrangeBadge(this.merchRevenueBadge);
    this.arrangeBadge(this.ticketRevenueBadge);
  }

  private arrangeBadge(badge: CustomerScoreItem) {
    if (badge?.available) {
      badge.earned ? this.earnedArray.push(badge) : this.notEarnedArray.push(badge);
    }
  }
}

/**
 * Blueprint for the order item.
 */
export class CustomerScoreItem {
  public name: string;
  public value: number;
  public threshold: number;
  public earned: boolean;
  public available: boolean;

  public displayText: string;
  public displayName: string;

  public translations: Array<any> = [
    { value: 'activity', translation: this.customerScoreTranslations.i18nActivity },
    { value: 'ticket_quantity', translation: this.customerScoreTranslations.i18nTicketQuantity },
    { value: 'ticket_revenue', translation: this.customerScoreTranslations.i18nTicketRevenue },
    { value: 'merch_quantity', translation: this.customerScoreTranslations.i18nMerchQuantity },
    { value: 'merch_revenue', translation: this.customerScoreTranslations.i18nMerchRevenue },
  ];

  constructor(customerScoreItem: any, private customerScoreTranslations: CustomerScoreTranslationsService, preferredCurrency: ClubCurrencyType) {
    this.name = customerScoreItem.name;
    this.value = customerScoreItem.value;
    this.threshold = customerScoreItem.threshold;
    this.earned = customerScoreItem.earned;
    this.available = customerScoreItem.available;

    this.displayName = this.setDisplayName(customerScoreItem.name);
    this.displayText = this.setDisplayText(preferredCurrency);
  }

  public setDisplayName(name: string): any {
    const displayName = this.translations.find(el => name === el.value);
    return displayName ? displayName.translation : name;
  }

  private setDisplayText(preferredCurrency): string {
    let text;
    if (this.name === 'activity') {
      text = this.customerScoreTranslations.i18nPurchased;
    } else if (this.name === 'ticket_revenue' || this.name === 'merch_revenue') {
      const currency = new Currency(parseFloat((this.value / 100).toString()).toFixed(2), preferredCurrency);
      text = `${currency.value} ${currency.currency}`;
    } else {
      text = this.value;
    }
    return text;
  }
}
